import useAuth from "hooks/useAuth";
import { useCallback } from "react";
import useRouter from "common/hooks/use-router";
import CrudEdit from "common/components/Crud/CrudEdit";
import AdminForm from "./AdminForm";

function MyAccountForm() {
  const router = useRouter();
  const { user } = useAuth();

  const back = useCallback(() => {
    router.navigate("/administrators");
  }, [router]);

  return user?.id ? (
    <CrudEdit
      collectionName="users"
      id={user.id}
      Form={AdminForm}
      onBack={back}
      myAccount
    />
  ) : null;
}

export default MyAccountForm;
